// Bare numbers below this threshold are interpreted as thousands —
// no normal US home asking price is under $10,000, so "499" almost
// certainly means $499,000.
const SHORTHAND_THRESHOLD = 10_000;

/** Parse user input into a numeric price. Accepts:
 *    499        → 499,000   (shorthand: bare numbers under 10k are thousands)
 *    499k       → 499,000
 *    1.2m / 1.2M → 1,200,000
 *    $499,000   → 499,000
 *    1500000    → 1,500,000
 *  Returns null if input can't be parsed.
 */
export function parsePriceInput(raw: string): number | null {
  if (!raw || !raw.trim()) return null;
  let s = raw.replace(/[$,\s]/g, "").toLowerCase();
  if (!s) return null;

  let multiplier = 1;
  if (s.endsWith("k")) {
    multiplier = 1_000;
    s = s.slice(0, -1);
  } else if (s.endsWith("m")) {
    multiplier = 1_000_000;
    s = s.slice(0, -1);
  }

  const n = parseFloat(s);
  if (!Number.isFinite(n) || n <= 0) return null;
  let result = n * multiplier;

  if (multiplier === 1 && result < SHORTHAND_THRESHOLD) {
    result = result * 1_000;
  }

  return Math.round(result);
}

export function formatPrice(n: number): string {
  return "$" + n.toLocaleString("en-US");
}
